import "../../App.css";
import "../../styling/Gallery.css";

// Images
import Carousel1 from "../../images/gallery/smile_THATShowDec_OwenBurnham-06.jpg";
import Carousel2 from "../../images/gallery/20240921_beedahbop-THATSHOWSept_OwenBurnham-08.jpg";
import Carousel3 from "../../images/gallery/20240921_FuckItBopIt-THATSHOWSept_OwenBurnham-03.jpg";
import Carousel4 from "../../images/gallery/20240921_FuckItBopIt-THATSHOWSept_OwenBurnham-10.jpg";
import Carousel5 from "../../images/gallery/20240921_GoBananas_THATSHOWSept_OwenBurnham-12.jpg";
import Carousel6 from "../../images/gallery/20240921_IBuiltaCastillo_THATSHOWSept_OwenBurnham-02.jpg";
import Carousel7 from "../../images/gallery/20240921_iflismaat_THATSHOWSept_OwenBurnham-07.jpg";
import Carousel8 from "../../images/gallery/20240921_iwtbotiwtwot-THATSHOWSept_OwenBurnham-12.jpg";
import Carousel9 from "../../images/gallery/20240921_PostShow_THATSHOWSept_OwenBurnham-02.jpg";
import Carousel10 from "../../images/gallery/20240921_PostShow_THATSHOWSept_OwenBurnham-04.jpg";
import Carousel11 from "../../images/gallery/20240921_PostShow_THATSHOWSept_OwenBurnham-08.jpg";
import Carousel12 from "../../images/gallery/20240921_PostShow_THATSHOWSept_OwenBurnham-14.jpg";
import Carousel13 from "../../images/gallery/20240921_Re-memberTheMysteryTHATSHOWSept_OwenBurnham-09.jpg";
import Carousel14 from "../../images/gallery/20240921_TheSpaceBetweenLips_THATSHOWSept_OwenBurnham-29.jpg";
import Carousel15 from "../../images/gallery/AdrienneSwan_THATshow_photoOwenBurnham-06.jpg";
import Carousel16 from "../../images/gallery/AdrienneSwan_THATshow_photoOwenBurnham-10.jpg";
import Carousel17 from "../../images/gallery/attaboy_THATShowDec_OwenBurnham-12.jpg";
import Carousel18 from "../../images/gallery/Bang_THATShowDec_OwenBurnham-10.jpg";
import Carousel19 from "../../images/gallery/DreamsandDecay_THATShowDec_OwenBurnham-13.jpg";
import Carousel20 from "../../images/gallery/MackLawrence.LuluWest_THATshow_photoOwenBurnham-07.jpg";
// import Carousel21 from "../../images/gallery/MackLawrence.LuluWest_THATshow_photoOwenBurnham-08.jpg";
// import Carousel22 from "../../images/gallery/MadiOhalloran.SumayyahSmith_THATshow_photoOwenBurnham-08.jpg";
// import Carousel23 from "../../images/gallery/PeterAlfredElizalde_THATshow_photoOwenBurnham-03.jpg";
// import Carousel24 from "../../images/gallery/PollDance_THATShowDec_OwenBurnham-06.jpg";
// import Carousel25 from "../../images/gallery/Postshow_THATShowDec_OwenBurnham-06.jpg";
// import Carousel26 from "../../images/gallery/Preshow_THATShowDec_OwenBurnham-05.jpg";
// import Carousel27 from "../../images/gallery/SheilaJackson_THATshow_photoOwenBurnham-09.jpg";
// import Carousel28 from "../../images/gallery/THATShow_postshow_photoOwenBurnham-14 (1).jpg";
// import Carousel29 from "../../images/gallery/THATShow_preshow_photoOwenBurnham-06.jpg";
// import Carousel30 from "../../images/gallery/THATShow-Macrh30-OwenBurnham-00.png";
// import Carousel31 from "../../images/gallery/THATShow-March29-OwenBurnham-06.jpg";
// import Carousel32 from "../../images/gallery/THATShow-March29-OwenBurnham-16.jpg";
// import Carousel33 from "../../images/gallery/THATShow-March29-OwenBurnham-31.jpg";
// import Carousel34 from "../../images/gallery/THATShow-March29-OwenBurnham-41.jpg";
// import Carousel35 from "../../images/gallery/THATShow-March29-OwenBurnham-47.jpg";
// import Carousel36 from "../../images/gallery/THATShow-March29-OwenBurnham-69.jpg";
// import Carousel37 from "../../images/gallery/THATShow-March29-OwenBurnham-74.jpg";
// import Carousel38 from "../../images/gallery/THATShow-March29-OwenBurnham-89.jpg";
// import Carousel39 from "../../images/gallery/THATShow-March29-OwenBurnham-105.jpg";
// import Carousel40 from "../../images/gallery/THATShow-March30-OwenBurnham-20.jpg";
// import Carousel41 from "../../images/gallery/THATShow-March30-OwenBurnham-34.jpg";
// import Carousel42 from "../../images/gallery/THATShow-March30-OwenBurnham-42.jpg";
// import Carousel43 from "../../images/gallery/THATShow-March30-OwenBurnham-58.jpg";
// import Carousel44 from "../../images/gallery/THATShow-March30-OwenBurnham-66.jpg";
// import Carousel45 from "../../images/gallery/THATShow-March30-OwenBurnham-72.jpg";
// import Carousel46 from "../../images/gallery/THATShow-March30-OwenBurnham-84.jpg";
// import Carousel47 from "../../images/gallery/THATShow-March30-OwenBurnham-098.jpg";
// import Carousel48 from "../../images/gallery/TheHauntingoftheResidencyattheLake_THATShowDec_OwenBurnham-13.jpg";
// import Carousel49 from "../../images/gallery/WHTDTBWCDAE_THATShowDec_OwenBurnham-07.jpg";

// Boostrap Imports
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Carousel from "react-bootstrap/Carousel";

function ImageGallery() {
  return (
    <Container className="tab_header">
      <Row>
        <Carousel fade wrap>
          <Carousel.Item>
            <img src={Carousel1} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel2} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel3} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel4} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel5} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel6} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel7} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel8} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel9} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel10} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel11} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel12} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel13} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel14} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel15} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel16} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel17} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel18} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel19} alt=""></img>
          </Carousel.Item>
          <Carousel.Item>
            <img src={Carousel20} alt=""></img>
          </Carousel.Item>
        </Carousel>
        <p
          className="credit"
          style={{ textAlign: "center", fontSize: "small" }}
        >
          All images by Owen Burnham
        </p>
      </Row>
    </Container>
  );
}

export default ImageGallery;
